import React from "react";
import CommonPage from "@icarius-common/commonPage";
import { getLocalizedString } from "@icarius-localization/strings";
import CustomIconButton from "@icarius-common/abmComponents/customIconButton";
import { ExpansionPanel, ExpansionPanelDetails, ExpansionPanelSummary, Grid, IconButton, Typography } from "@material-ui/core";
import { Alert } from "@material-ui/lab";
import { CloseIcon, ExpandMoreIcon } from "@icarius-icons/index";
import ModuleFormDialog from "./moduleFormDialog";
import ActivityFormDialog from "./activityFormDialog";
import useCourse from "./useCourse";

const CoursePage = (props) => {

  const {
    course,
    handleGoBack,
  } = props;

  const {
    modules,
    activities,
    media,
    activityTypes,
    questionTypes,
    sessionTypes,
    activityFormData,
    isLoading,
    state,
    handlers,
  } = useCourse(course.id);

  const readOnly = course.isInUse;

  const createModuleButton = () => (
    <CustomIconButton
      title={getLocalizedString("create")}
      onClick={() => handlers.handleOpenCreateModuleForm()}
      type={"add"}
    />
  )

  const editModuleButton = (gridRef) => (
    <CustomIconButton
      title={getLocalizedString("edit")}
      onClick={() => handlers.handleOpenUpdateModuleForm(gridRef)}
      type={"edit"}
    />
  )

  const previewModuleButton = (gridRef) => (
    <CustomIconButton
      title={getLocalizedString("view")}
      onClick={() => handlers.handleOpenUpdateModuleForm(gridRef)}
      type={"preview"}
    />
  )

  const deleteModuleButton = (gridRef) => (
    <CustomIconButton
      title={getLocalizedString("delete")}
      onClick={() => handlers.handleOpenDeleteModuleDialog(gridRef)}
      type={"delete"}
    />
  )

  const createActivityButton = () => (
    <CustomIconButton
      title={getLocalizedString("create")}
      onClick={() => handlers.handleOpenCreateActivityForm()}
      type={"add"}
    />
  )

  const editActivityButton = (gridRef) => (
    <CustomIconButton
      title={getLocalizedString("edit")}
      onClick={() => handlers.handleOpenUpdateActivityForm(gridRef)}
      type={"edit"}
    />
  )

  const viewActivityButton = (gridRef) => (
    <CustomIconButton
      title={getLocalizedString("view")}
      onClick={() => handlers.handleOpenUpdateActivityForm(gridRef)}
      type={"preview"}
    />
  )

  const deleteActivityButton = (gridRef) => (
    <CustomIconButton
      title={getLocalizedString("delete")}
      onClick={() => handlers.handleOpenDeleteActivityDialog(gridRef)}
      type={"delete"}
    />
  )

  return (
    <div style={{ marginBottom: 20 }}>
      <CommonPage
        isLoading={isLoading}
        isNotGridPage
      >
        <Grid container item xs={12} alignItems="center" justify="space-between" style={{ paddingTop: 10, paddingLeft: 24 }}>
          <Typography className="whiteText" style={{ fontSize: 18, fontWeight: 500 }}>
            {getLocalizedString("modulesAndActivitiesFromCourse", { courseName: course.name })}
          </Typography>
          <IconButton onClick={handleGoBack}>
            <CloseIcon className="whiteText" />
          </IconButton>
        </Grid>
        {
          course.isInUse &&
          <div style={{ width: "100%", padding: 14 }}>
            <Alert variant="filled" severity="info">
              {getLocalizedString("courseInUseUpdate")}
            </Alert>
          </div>
        }
        <ExpansionPanel
          defaultExpanded={false}
          style={{ background: "transparent", boxShadow: "none" }}
        >
          <ExpansionPanelSummary
            style={{ padding: "0px 40px" }}
            expandIcon={<ExpandMoreIcon />}
          >
            <Typography className="whiteText" style={{ fontWeight: 600 }}>
              {getLocalizedString("modules")}
            </Typography>
          </ExpansionPanelSummary>
          <ExpansionPanelDetails>
            <CommonPage
              gridHeight={520}
              columnDefPage={"/coursesMaster/modules"}
              rowData={modules}
              menuItems={readOnly ? [previewModuleButton] : [createModuleButton, editModuleButton, deleteModuleButton]}
              ignoreProcessesbyPath
            />
          </ExpansionPanelDetails>
        </ExpansionPanel>
        <ExpansionPanel
          defaultExpanded={false}
          style={{ background: "transparent", boxShadow: "none" }}
        >
          <ExpansionPanelSummary
            style={{ padding: "0px 40px" }}
            expandIcon={<ExpandMoreIcon />}
          >
            <Typography className="whiteText" style={{ fontWeight: 600 }}>
              {getLocalizedString("activities")}
            </Typography>
          </ExpansionPanelSummary>
          <ExpansionPanelDetails>
            <CommonPage
              gridHeight={520}
              columnDefPage={"/coursesMaster/activities"}
              rowData={activities}
              menuItems={readOnly ? [viewActivityButton] : [createActivityButton, editActivityButton, deleteActivityButton]}
              ignoreProcessesbyPath
            />
          </ExpansionPanelDetails>
        </ExpansionPanel>
      </CommonPage>
      {
        state.moduleFormIsOpen &&
        <ModuleFormDialog
          open={state.moduleFormIsOpen}
          readOnly={readOnly}
          isLoading={isLoading}
          nextOrder={(modules[modules.length - 1]?.order || 0) + 1}
          data={state.selectedModule}
          submitCallback={state.selectedModule ? handlers.handleUpdateModule : handlers.handleCreateModule}
          handleClose={handlers.handleCloseModuleForm}
        />
      }
      {
        state.activityFormIsOpen &&
        <ActivityFormDialog
          open={state.activityFormIsOpen}
          readOnly={readOnly}
          isLoading={isLoading}
          data={activityFormData}
          activities={activities}
          nextOrder={(activities[activities.length - 1]?.order || 0) + 1}
          modules={modules}
          activityTypes={activityTypes}
          media={media}
          questionTypes={questionTypes}
          sessionTypes={sessionTypes}
          invalidFiles={state.activityInvalidFiles}
          submitCallback={activityFormData ? handlers.handleUpdateActivity : handlers.handleCreateActivity}
          handleClearInvalidFiles={handlers.handleClearInvalidFiles}
          handleClose={handlers.handleCloseActivityForm}
        />
      }
    </div>
  )
}

export default CoursePage;